import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { api } from "../../../../../../util/APIConfig"
import { useState } from "react"
import Button from "../../../../../../components/UI/Button"
import Container from "../../../../../../components/UI/Container"
import QuestionEditor from "../../CreateQuestion/QuestionEditor"
import CkQuestionEditor from "../../CreateQuestion/CkQuestionEditor"
import { AiOutlinePlusCircle } from "react-icons/ai"
import { toast } from "react-toastify"
import Error from "../../../../../../components/Status/Error"
import Spinner from "../../../../../../components/Spinner"
import Assignments from "./Assignments"
import PlusIcon from "../../../../../../components/svg/PlusIcon"
import { BeatLoader } from "react-spinners"
import { FaTrash } from "react-icons/fa"
import DeleteAssignment from "./DeleteAssignment"

import CustomScript from './CustomScript';

const answers = [
  { id: 1, title: "A", body: "" },
  { id: 2, title: "B", body: "" },
  { id: 3, title: "C", body: "" },
  { id: 4, title: "D", body: "" },
  { id: 5, title: "E", body: "" },
]

const questionStyle = [
  { id: 1, name: "MCQ" },
  { id: 2, name: "Essay Response" },
  { id: 3, name: "Fill in the Blanks" },
  { id: 4, name: "Equation Response" }
]

const questionDataAnswerInitialValue = [
  {
    id: 1,
    title: "Question Data",
    body: ""
  }
]

const questionTextAnswerInitialValue = [
  {
    id: 1,
    title: "Question Text",
    body: ""
  }
]

const solutionInitialValue = [
  {
    id: 1,
    title: "Solution",
    body: ""
  }
]

function getNameFromId(id) {
  switch (id) {
    case 1:
      return "MCQ"
    case 2:
      return "Essay Response"
    case 3:
      return "Fill in the Blanks"
    case 4:
      return "Equation Response"
    default:
      return "MCQ"
  }
}

export default function Edit() {
  const { id } = useParams()
  const [isFetching, setIsFetching] = useState(true)
  const [fetchError, setFetchError] = useState(null)
  const [isAddingAssignment, setIsAddingAssignment] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)

  const [assignmentsData, setAssignmentsData] = useState([])

  const [correctAnswer, setCorrectAnswer] = useState("")
  const [answerOptions, setAnswerOptions] = useState([])
  const [solution, setSolution] = useState(solutionInitialValue)
  const [questionDataAnswer, setQuestionDataAnswer] = useState(
    questionDataAnswerInitialValue
  )
  const [questionTextAnswer, setQuestionTextAnswer] = useState(
    questionTextAnswerInitialValue
  )
  const [selectedQuestionStyle, setSelectedQuestionStyle] = useState(
    questionStyle[0]
  )

  const [questionAssignments, setQuestionAssignments] = useState([])

  const [showDeleteAssignmentModal, setShowDeleteAssignmentModal] =
    useState(false)

  const [optionAdded, setOptionAdded] = useState(null)

  const [body, setBody] = useState({})

  const navigate = useNavigate()

  async function getQuestionInfoByQuestionId(id) {
    setIsFetching(true)
    try {
      let response = await api("/question/admin/question/" + id)

      response = response.data

      const sortedAnswers = response.data.answers.sort(
        (a, b) => a.letter.charCodeAt(0) - b.letter.charCodeAt(0)
      )
      const answers = sortedAnswers.map(answer => {
        return {
          id: answer.id,
          title: answer.letter,
          body: answer.text,
          isCorrect: answer.isCorrect
        }
      })
      const correctAnswer = answers.find(answer => answer.isCorrect === true)
      setQuestionAssignments(response.data.questionAssignments)

      setQuestionDataAnswer([
        {
          id: 1,
          title: "Question Data",
          body: response.data.data
        }
      ])
      setQuestionTextAnswer([
        {
          id: 1,
          title: "Question Text",
          body: response.data.text
        }
      ])
      setSolution([
        {
          id: 1,
          title: "Solution",
          body: response.data.solution
        }
      ])
      setSelectedQuestionStyle({
        id: response.data.questionType,
        name: getNameFromId(response.data.questionType)
      })
      if (
        response.data.questionType === 1 ||
        response.data.questionType === 3
      ) {
        setAnswerOptions(answers)
        setCorrectAnswer(correctAnswer.title)
      }
    } catch (error) {
      setFetchError(error)
      console.log(error)
    } finally {
      setIsFetching(false)
    }
  }

  async function deleteAssignment() {
    try {
      const response = await api.post(
        "question/admin/Question/RemoveQuestionAssignments",
        body
      )
      toast.success(response.data.message)
      getQuestionInfoByQuestionId(id.slice(3))
    } catch (error) {
      toast.error(
        error.response.data.message
          ? error.response.data.message
          : "Something went wrong"
      )
    }
  }

  async function updateQuestion() {
    setIsUpdating(true)
    const updatedAnswers =
      selectedQuestionStyle.id === 1 || selectedQuestionStyle.id === 3
        ? answerOptions.map(answer => {
            return {
              letter: answer.title,
              text: answer.body,
              isCorrect: answer.title === correctAnswer
            }
          })
        : []

    const body = {
      id: id.slice(3),
      solution: solution[0].body,
      data: questionDataAnswer[0].body,
      text: questionTextAnswer[0].body,
      questionType: selectedQuestionStyle.id,
      answers: updatedAnswers
    }

    try {
      await api.post("/question/admin/Question/Update", body)
      toast.success("Question Updated Successfully")
      navigate("/question-bank/question-admin/edit-question")
    } catch (error) {
      toast.error(
        error.response?.data?.message
          ? error.response.data.message
          : "Something went wrong!"
      )
    } finally {
      setIsUpdating(false)
    }
  }

  function removeAssignment(id) {
    const newAssignmentsData = [...assignmentsData]
    const index = newAssignmentsData.findIndex(item => item.id === id)
    newAssignmentsData.splice(index, 1)
    setAssignmentsData(newAssignmentsData)
  }

  function clearAssignmentData(id) {
    const newAssignmentsData = assignmentsData.map(item => {
      if (item.id === id) {
        return {
          id: item.id
        }
      }
      return item
    })
    setAssignmentsData(newAssignmentsData)
  }

  function addAssignment() {
    const newAssignmentsData = [...assignmentsData]
    newAssignmentsData.push({
      id: new Date().getTime()
    })
    setAssignmentsData(newAssignmentsData)
  }

  function addAssignmentsData(data, id) {
    const newAssignmentsData = assignmentsData.map(item => {
      if (item.id === id) {
        return {
          ...item,
          ...data
        }
      }
      return item
    })
    setAssignmentsData(newAssignmentsData)
  }

  async function addAssignments() {
    setIsAddingAssignment(true)

    for (let item of assignmentsData) {
      if (!item.questionLocation) {
        toast.error("Please select a question location")
        setIsAddingAssignment(false)
        return
      }
      if (!item.admissionTestId) {
        toast.error("Please select an admission test")
        setIsAddingAssignment(false)
        return
      }
    }

    const questionAssignments = assignmentsData.map(item => {
      return {
        admissiontestId: item.admissionTestId ? item.admissionTestId : null,
        examSectionId: item.examSectionNumberId
          ? item.examSectionNumberId
          : null,
        paperLink: item.paperLink ? item.paperLink : null,
        paperQuestion: item.paperQuestions ? Number(item.paperQuestions) : null,
        paperType: item.paperTypeId ? item.paperTypeId : null,
        questionLocation: item.questionLocation ? item.questionLocation : null,
        year: item.year ? item.year : null,
        mockpapernumber: item.mockPaperNumber
          ? Number(item.mockPaperNumber)
          : null,
        sectionId: item.sectionNumberId ? item.sectionNumberId : null,
        subjectId: item.subjectId ? item.subjectId : null,
        topicId: item.topicId ? item.topicId : null,
        examId: item.examId ? item.examId : null
      }
    })

    const body = {
      questionId: id.slice(3),
      questionAssignments: questionAssignments
    }

    try {
      const response = await api.post(
        "question/admin/Question/AddQuestionAssignments",
        body
      )
      if (response.data.success) {
        toast.success("Assignments Added Successfully")
      }
      getQuestionInfoByQuestionId(id.slice(3))
      setAssignmentsData([])
    } catch (error) {
      toast.error(
        error.response.data.message
          ? error.response.data.message
          : "Something went wrong"
      )
    } finally {
      setIsAddingAssignment(false)
    }
  }

  function questionDataChange(newValue, answerOpts, answerOptionID){
    answerOpts &&
      setQuestionDataAnswer(
        answerOpts.map(answerOption => {
          if (answerOption.id === answerOptionID) {
            return {
              ...answerOption,
              body: newValue
            }
          }
          return answerOption
        })
      )
  }

  function questionTextChange(newValue, answerOpts, answerOptionID){
    answerOpts &&
      setQuestionTextAnswer(
        answerOpts.map(answerOption => {
          if (answerOption.id === answerOptionID) {
            return {
              ...answerOption,
              body: newValue
            }
          }
          return answerOption
        })
      )
  }

  function questionSolutionChange(newValue, answerOpts, answerOptionID){
    answerOpts &&
      setSolution(
        answerOpts.map(answerOption => {
          if (answerOption.id === answerOptionID) {
            return {
              ...answerOption,
              body: newValue
            }
          }
          return answerOption
        })
      )
  }

  function questionOptionChange(newValue, answerOptionID){
    setAnswerOptions(prevState => 
        prevState.map(answerOption => {
            if (answerOption.id === answerOptionID) {
                return {
                    ...answerOption,
                    body: newValue
                }
            }
            return answerOption
        })
    );
  }

  function setupCkEditorOnElement(element_id, onChange){
    const ckE = window.CKEDITOR
    if(!ckE) return
    if(ckE.instances[element_id]) return
    ckE.replace(element_id);
    ckE.instances[element_id].on('change', function() {
      const editorContent = ckE.instances[element_id].getData();
      onChange(editorContent)
    });
  }

  function safeDestroyEditor(editorId) {
    const cke = window.CKEDITOR
    if (cke.instances[editorId]) {
      try {
        cke.instances[editorId].destroy(true);
      } catch (error) {
        // console.error(`Error destroying CKEditor instance: ${error}`);
      } finally {
        delete cke.instances[editorId];
      }
    }
  }

  useEffect(() => {
    getQuestionInfoByQuestionId(id.slice(3))
  }, [id])

  useEffect(() => {
    if(!optionAdded) return
    
    const name = `option_${optionAdded.title.toLowerCase()}`
      setupCkEditorOnElement(name, (newValue) => {
        questionOptionChange(newValue, optionAdded.id)
      }) 

  }, [optionAdded])

  useEffect(() => {

    return () => {
      if(!window.CKEDITOR) return
      for (var name in window.CKEDITOR.instances) {
        safeDestroyEditor(name)
      }
    };
  }, [])

  if (isFetching) return <Spinner type="child" />

  if (fetchError) return <Error />

  return (
    <>   
      <CustomScript
        src="/ckeditor/ckeditor.js"
        onLoad={() => { 

          if(window.CKEDITOR){
            setupCkEditorOnElement('solution', (newValue) => {
              questionSolutionChange(newValue, solution, solution[0].id)
            }) 
            setupCkEditorOnElement('question_data', (newValue) => {
              questionDataChange(newValue, questionDataAnswer, questionDataAnswer[0].id)
            }) 
            setupCkEditorOnElement('question_text', (newValue) => {
              questionTextChange(newValue, questionTextAnswer, questionTextAnswer[0].id)
            }) 
            
            {(selectedQuestionStyle.id === 1 || selectedQuestionStyle.id === 3) &&
              answerOptions.map((option, index) => {

                const name = `option_${option.title.toLowerCase()}`
                setupCkEditorOnElement(name, (newValue) => {
                  questionOptionChange(newValue, option.id)
                }) 
              }
            )}
          }
        }}
      />
      <Container className="container-in">
        <DeleteAssignment
          deleteAssignment={deleteAssignment}
          isOpen={showDeleteAssignmentModal}
          setIsOpen={setShowDeleteAssignmentModal}
        />

        <div
          className={`${isUpdating ? "pointer-events-none" : ""}
          flex justify-end pb-8`}
          onClick={updateQuestion}
        >
          <Button
            bgColor="primary"
            className="flex h-10 w-60 items-center justify-center bg-primary"
          >
            {isUpdating ? (
              <BeatLoader color="#fff" size={10} />
            ) : (
              <span className="text-white">Update</span>
            )}
          </Button>
        </div>
        {questionAssignments.length > 0 &&
          questionAssignments.map(item => (
            <div
              className="shadow-4 mb-8 flex w-full flex-col justify-between rounded-[14px] bg-white p-12"
              key={item.id}
            >
              {item.questionLocation === 1 && (
                <div className="grid grid-cols-4 gap-9">
                  <div>
                    <p className="pb-2 font-bold text-neutral-1">
                      Question Location:
                    </p>
                    <span className="text-neutral-1d">Revise</span>
                  </div>
                  <div>
                    <p className="pb-2 font-bold text-neutral-1">
                      Admission Test:
                    </p>
                    <span className="text-neutral-1d">
                      {item.admissionTestName}
                    </span>
                  </div>
                  <div>
                    <p className="pb-2 font-bold text-neutral-1">
                      Section Number:
                    </p>
                    <span className="text-neutral-1d">{item.sectionNo}</span>
                  </div>
                  <div>
                    <p className="pb-2 font-bold text-neutral-1">Subject:</p>
                    <span className="text-neutral-1d">{item.subjectName}</span>
                  </div>
                  <div>
                    <p className="pb-2 font-bold text-neutral-1">Topic:</p>
                    <span className="text-neutral-1d">{item.topicName}</span>
                  </div>
                </div>
              )}

              {item.questionLocation === 2 && (
                <div className="grid grid-cols-4 gap-9">
                  <div>
                    <p className="pb-2 font-bold text-neutral-1">
                      Question Location:
                    </p>
                    <span className="text-neutral-1d">Simulate</span>
                  </div>
                  <div>
                    <p className="pb-2 font-bold text-neutral-1">
                      Admission Test:
                    </p>
                    <span className="text-neutral-1d">
                      {item.admissionTestName}
                    </span>
                  </div>

                  <div>
                    <p className="pb-2 font-bold text-neutral-1">Subject:</p>
                    <span className="text-neutral-1d">
                      {item.subjectName ? item.subjectName : "N/A"}
                    </span>
                  </div>

                  <div>
                    <p className="pb-2 font-bold text-neutral-1">
                      Type of Paper:
                    </p>
                    <span className="text-neutral-1d">
                      {item.paperType === 1 ? "Past Paper" : "Mock Paper"}
                    </span>
                  </div>
                  <div>
                    <p className="pb-2 font-bold text-neutral-1">
                      Paper Questions:
                    </p>
                    <span className="text-neutral-1d">{item.paperQuestion}</span>
                  </div>
                  <div>
                    <p className="pb-2 font-bold text-neutral-1">
                      Exam Section Number:
                    </p>
                    <span className="text-neutral-1d">
                      {item.examSectionNumber}
                    </span>
                  </div>
                  <div>
                    <p className="font-bold text-neutral-1">Paper Link:</p>
                    <span>{item.paperLink}</span>
                  </div>
                  <div>
                    <p className="pb-2 font-bold text-neutral-1">
                      Year:
                    </p>
                    <span className="text-neutral-1d">
                      {item.year}
                    </span>
                  </div>
                </div>
              )}
              <div className="flex justify-end gap-4 pt-4">
                <div className="group">
                  <button
                    className="rounded-lg border border-neutral-2 px-3.5 py-3 group-hover:border-danger"
                    onClick={() => {
                      setShowDeleteAssignmentModal(true)
                      const body = {
                        questionId: item.questionId,
                        questionAssignmentIds: [item.id]
                      }
                      setBody(body)
                    }}
                  >
                    <FaTrash
                      size={20}
                      className="text-neutral-2 group-hover:text-danger"
                    />
                  </button>
                </div>
              </div>
            </div>
          ))}
        <div className="flex justify-end pb-8">
          <button
            className="shadow-3 flex items-center gap-3 rounded-lg border-2 border-primary bg-transparent px-8 py-2 font-semibold"
            onClick={addAssignment}
          >
            <PlusIcon />
            <span className="font-semibold text-primary">Add Assignment</span>
          </button>
        </div>
        {assignmentsData.map(item => (
          <div key={item.id} className="mb-8">
            <Assignments
              id={item.id}
              addAssignmentsData={addAssignmentsData}
              removeAssignment={removeAssignment}
              clearAssignmentData={clearAssignmentData}
            />
          </div>
        ))}
        {assignmentsData.length > 0 && (
          <div
            className={`${isAddingAssignment ? "pointer-events-none" : ""}
          flex justify-end pb-8`}
            onClick={addAssignments}
          >
            <Button
              bgColor="primary"
              className="flex h-10 w-60 items-center justify-center bg-primary"
            >
              {isAddingAssignment ? (
                <BeatLoader color="#fff" size={10} />
              ) : (
                <span className="text-white">Update Assignments</span>
              )}
            </Button>
          </div>
        )}
        <div className="flex flex-col gap-10">
          <div className="grid grid-cols-2.2 gap-6">
            <CkQuestionEditor
              title="Question Data"
              color="bg-primary"
              answerOptions={questionDataAnswer}
              setAnswerOptions={setQuestionDataAnswer}
              answerOptionID={questionDataAnswer[0].id}
              answerBody={questionDataAnswer[0].body}
              showMathSymbol={true}
              name="question_data"
            />
            <CkQuestionEditor
              title="Question Text"
              color="bg-primary"
              answerOptions={questionTextAnswer}
              setAnswerOptions={setQuestionTextAnswer}
              answerOptionID={questionTextAnswer[0].id}
              answerBody={questionTextAnswer[0].body}
              showMathSymbol={true}
              name="question_text"
            />

            <CkQuestionEditor
              title="Solution"
              color="bg-secondary-yellow"
              className="col-start-1 col-end-3"
              answerOptions={solution}
              setAnswerOptions={setSolution}
              answerOptionID={solution[0].id}
              answerBody={solution[0].body}
              showMathSymbol={true}
              name="solution"
            />

            {(selectedQuestionStyle.id === 1 || selectedQuestionStyle.id === 3) &&
              answerOptions.map((option, index) => (
                <CkQuestionEditor
                  key={option.id}
                  title={`Answer ${option.title} / Passage ${option.title}`}
                  color="bg-secondary-green"
                  deleteOption={true}
                  answerOptionID={option.id}
                  setAnswerOptions={setAnswerOptions}
                  answerOptions={answerOptions}
                  answerBody={option.body}
                  showMathSymbol={true}
                  index={index}
                  name={`option_${option.title.toLowerCase()}`}
                />
              ))}

            {(selectedQuestionStyle.id === 1 ||
              selectedQuestionStyle.id === 3) && (
              <button
                className="flex flex-col items-center justify-center gap-5 rounded-[14px] bg-white py-24"
                onClick={() => {

                  let newOption = {
                    id: answerOptions.length + 1,
                    title: String.fromCharCode(answerOptions.length + 65).toLowerCase(),
                    body: ""
                  }

                  setAnswerOptions([
                    ...answerOptions,
                    newOption
                  ])

                  setTimeout(() => {
                    setOptionAdded(newOption)
                  }, 3000)
                }}
              >
                <AiOutlinePlusCircle
                  className="text-2xl text-secondary-green"
                  size={74}
                />
                <p className="text-heading-4 font-medium text-neutral-1">
                  Add Answer/ Passage
                </p>
              </button>
            )}
          </div>

          {(selectedQuestionStyle.id === 1 || selectedQuestionStyle.id === 3) && (
            <QuestionEditor
              title="Correct Answer"
              color="bg-secondary-yellow"
              editorDisabled={true}
            >
              <div className="booking-form answer-options flex flex-wrap gap-6 p-12">
                {answerOptions.map(option => (
                  <div
                    key={option.id}
                    className="flex cursor-pointer items-center gap-3 text-neutral-1"
                  >
                    <input
                      type="radio"
                      name="answerOptions"
                      value={option.title}
                      id={option.id}
                      onChange={e => setCorrectAnswer(e.target.value)}
                      defaultChecked={option.title === correctAnswer}
                    />
                    <label
                      htmlFor={option.title}
                      className="heading-4l cursor-pointer leading-6"
                    >
                      {option.title}
                    </label>
                  </div>
                ))}
              </div>
            </QuestionEditor>
          )}
        </div>
      </Container>
    </> 
  )
}
